'use client';

import styled from 'styled-components';

import { breakpoints } from '@styles/breakpoint';
import { Spacers } from '@styles/theme';

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: calc(${Spacers.XL}rem + ${Spacers.XL}rem) 0;
  width: 100%;

  ${breakpoints.desktopOrBigger} {
    margin: calc(${Spacers.XXL}rem + ${Spacers.XXL}rem + ${Spacers.SM}rem) 0;
  }
`;

export const ButtonWraper = styled.div`
  margin-top: ${Spacers.LG}rem;
`;

export const SearchResults = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${Spacers.LG}rem;
`;

export const ResultContainer = styled.div`
  margin-top: ${Spacers.BASE}rem;
  flex: 1;
  height: 100%;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18.75rem;
  width: 100%;
`;

export const ContactSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.LG}rem;
`;

export const PhoneWrapper = styled.div`
  margin-top: ${Spacers.LG}rem;
`;

export const ContactInfoSection = styled.div`
  margin-top: ${Spacers.LG}rem;
  display: flex;
  flex-direction: column;
`;

export const SchoolItem = styled.div<{ $isSelected: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  cursor: pointer;

  &:hover {
    /* Only target Text components inside the first div (HeaderContainer) when hovering */
    > div:first-child {
      p,
      span {
        color: ${({ theme }) => theme.colors.actionDefault};
      }
    }
  }
`;

export const SelectedSchool = styled.div`
  cursor: pointer;
  border-radius: 0.5rem;
`;

export const Container = styled.div`
  display: flex;
  gap: ${Spacers.XS}rem;
`;

export const CodeContainer = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.typographyHeadersLight};
  padding: ${Spacers.SM}rem ${Spacers.BASE}rem;
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  width: 7.1rem;
  height: 2.625rem;
  background-color: ${({ theme }) => theme.colors.backgroundAccent};
  border: none;
  border-radius: 0.5rem;
  gap: ${Spacers.MD}rem;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.XL}rem;
  margin-top: ${Spacers.LG}rem;
  margin-bottom: calc(${Spacers.XXL}rem + ${Spacers.LG}rem + ${Spacers.MD}rem);
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.BASE}rem;
`;

export const StreetSection = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const SearchImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TextHeader = styled.span`
  color: ${({ theme }) => theme.colors.backgroundDark};
  font-weight: bold;
`;
